import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PaymentStatusEnum } from '@app/core/services/transaction/model/enum/payment-status.enum';

@Component({
  selector: 'ap-recover-externally-modal',
  templateUrl: './recover-externally-modal.component.html',
  styleUrl: './recover-externally-modal.component.css',
  standalone: false
})
export class RecoverExternallyModalComponent implements OnInit {

  recoverExternallyFormGroup: UntypedFormGroup;
  PaymentStatus = PaymentStatusEnum;

  get comment() { return this.recoverExternallyFormGroup.get('comment'); }

  constructor(private dialogRef: MatDialogRef<RecoverExternallyModalComponent>, private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  onSubmitRecoverExternallyForm() {
    this.dialogRef.close({
      comment: this.comment.value
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  private initForm() {
    this.recoverExternallyFormGroup = this.fb.group({
      comment: this.fb.control(''),
    });
  }

}
